import React, { useState, useEffect } from "react";
import { Card, Col, Row } from "antd";
import GuideForm from "@/pages/guide/GuideForm";
import "@/styles/pages/guides.scss";
import { getGuideListBasedOnFilter } from "@/services/services/getGuideListBasedOnFilter";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setFilteredGuide, setLastGuideSearchCriteria } from "@/reducers/guideSlice";
import { getUserPreferencesHistory } from "@/services/users/getUserPreferences";
import CardComponent from "@/components/card";
import { getIsLoggedIn } from "@/reducers/commonSlice";
import { showNotification } from "@/components/toaster/Toaster";
import { useSearchParams } from "react-router-dom";

const Guides = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedGuide, setSelectedGuide] = useState(null);
  const [userPreferences, setUserPreferences] = useState([]);
  const isLoggedIn = useSelector(getIsLoggedIn);
  // get disciplineId and countryCode from url params
  const [searchParams] = useSearchParams();
  const disciplineId = searchParams.get("disciplineId");
  const disciplineName = searchParams.get("disciplineName");
  const countryCode = searchParams.get("countryCode");
  const countryName = searchParams.get("countryName");
  // console.log({
  //   disciplineId,
  //   disciplineName,
  //   countryCode,
  //   countryName,
  // });

  // Set initial values for the form
  useEffect(() => {
    if (
      (countryCode && disciplineId && disciplineName && disciplineName) ||
      (countryCode && countryName)
    ) {
      const values = {
        country: {
          code: countryCode,
          name: countryName,
        },
        regions: null,
        levels: null,
        disciplines:
          disciplineId && disciplineName
            ? [
                {
                  id: parseInt(disciplineId),
                  name: disciplineName,
                },
              ]
            : null,
        universities: null,
      };

      setTimeout(() => {
        setSelectedGuide(values);
      }, 300);
    }
  }, [countryCode, disciplineId, disciplineName]);

  useEffect(() => {
    getUserPreferencesHistory()
      .then((data) => setUserPreferences(Object.values(data)))
      .catch((error) => {
        console.error("Error fetching search history:", error);
      });
  }, []);

  const handleFinish = (value) => {
    const filterData = {
      ...value,
      levelIds: value.levelIds
        ? Array.isArray(value.levelIds)
          ? [...value.levelIds]
          : [value.levelIds]
        : [],
    };
    if (!isLoggedIn) {
      dispatch(setLastGuideSearchCriteria(filterData));
    }
    getGuideListBasedOnFilter(filterData)
      .then((response) => {
        dispatch(setFilteredGuide(response));
        navigate("/guide-list");
      })
      .catch((error) => {
        console.error("Error fetching guides:", error);
        showNotification(
          "error",
          "Error fetching guides",
          error?.response?.data?.msg ?? "Something went wrong"
        );
      });
  };

  return (
    <div className="find-guide-wrapper">
      <GuideForm
        handleFinish={handleFinish}
        title="Find Mentors"
        subtitle={
          <div>
            <p>Share your study goals to match you with the perfect mentor.</p>
            <p style={{ marginTop: "0.25rem" }}>
              You get 3 unique searches. Each ‘Find Mentors’ click counts, even if you change
              filters. Choose wisely!
            </p>
          </div>
        }
        initialValues={selectedGuide}
        historyCount={userPreferences?.length}
      />
      {isLoggedIn ? (
        <div style={{ marginTop: "2rem" }}>
          <h3
            style={{
              backgroundColor: "#1c1c2c",
              borderTopRightRadius: "15px",
              borderTopLeftRadius: "15px",
              padding: "5px",
            }}
          >
            Search History
          </h3>
          <Row gutter={[16, 16]}>
            {userPreferences?.map((pref, index) => (
              <Col xs={24} sm={12} key={index} style={{ marginBottom: "8px" }}>
                <Card
                  title={pref.country.name}
                  onClick={() => {
                    console.log("Selected Guide:", pref);
                    setSelectedGuide(pref);
                  }}
                  style={{
                    cursor: "pointer",
                    border:
                      selectedGuide && JSON.stringify(selectedGuide) === JSON.stringify(pref)
                        ? "1px solid orange"
                        : "1px solid #f0f0f0",
                  }}
                >
                  <p>
                    <strong>Level:</strong> {pref.levels?.map((level) => level.name).join(", ")}
                  </p>
                  <p>
                    <strong>Discipline:</strong>{" "}
                    {pref.disciplines?.map((disc) => disc.name).join(", ")}
                  </p>
                  <p>
                    <strong>Regions:</strong> {pref.Regions?.map((disc) => disc.name).join(", ")}
                  </p>
                  <p>
                    <strong>Universities:</strong>{" "}
                    {pref.universities?.map((disc) => disc.name).join(", ")}
                  </p>
                </Card>
              </Col>
            ))}
            {userPreferences.length === 0 && (
              <Col span={24}>
                <CardComponent title="No Search History" />
              </Col>
            )}
          </Row>
        </div>
      ) : null}
    </div>
  );
};

export default Guides;
